import {
  COLLECTIONS_LOAD_COLLECTION_ITEM_BEGIN,
  COLLECTIONS_LOAD_COLLECTION_ITEM_SUCCESS,
  COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE,
  COLLECTIONS_LOAD_COLLECTION_ITEM_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function loadCollectionItem(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_LOAD_COLLECTION_ITEM_BEGIN,
    });
    const { projectId, collectionName, itemId, decryptFields, version } = args;
    const promise = new Promise((resolve, reject) => {
      const header = builderSurfaceJsonContentHeader(projectId);
      // if (args.decryptFields) header.params = { decryptFields: true };

      header.params = { decryptFields: true, formatDate: false };

      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/item/${itemId}/`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_LOAD_COLLECTION_ITEM_SUCCESS,
              data: res.data && res.data ? res.data : null,
            });
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE,
              data: { error: 'Failed' },
            });
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCollectionItemError() {
  return {
    type: COLLECTIONS_LOAD_COLLECTION_ITEM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_LOAD_COLLECTION_ITEM_BEGIN:
      return {
        ...state,
        loadCollectionItemPending: true,
        loadCollectionItemError: null,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEM_SUCCESS:
      return {
        ...state,
        loadCollectionItemPending: false,
        loadCollectionItemError: null,
        selectedItem: action.data,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEM_FAILURE:
      return {
        ...state,
        loadCollectionItemPending: false,
        loadCollectionItemError: action.data.error,
      };

    case COLLECTIONS_LOAD_COLLECTION_ITEM_DISMISS_ERROR:
      return {
        ...state,
        loadCollectionItemError: null,
      };

    default:
      return state;
  }
}
